// extracted by mini-css-extract-plugin
module.exports = {"default":"modal_default__5loYT","visible":"modal_visible__2ed-G","aligned":"modal_aligned__2076H"};